/* eslint-disable max-len */
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControl,
  TextField,
  Typography,
} from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers';
import React from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import postDeploymentDetails from '../../../../api/private/deployment/postDeployementDetails';
import ReleaseNoteEditor from './ReleaseNoteEditor';

function CreateNewSchedule({
  onAddSuccess,
  open,
  handleClose,
}) {
  const [fromDateAndTime, setFromDateAndTime] = React.useState(new Date());
  const [toDateAndTime, setToDateAndTime] = React.useState(new Date());
  const [deploymentmode, setDeploymentmode] = React.useState('Yes');
  const [submitDisabled, setSubmitDisabled] = React.useState(true);
  const [releaseNoteDisabled, setReleaseNoteDisabled] = React.useState(true);
  const [releaseNotes, setReleaseNotes] = React.useState('');
  const [reason, setReason] = React.useState('');
  const userName = useSelector((state) => state.user.userProfile.email);
  const [timeError, setTimeError] = React.useState('');
  const [startTimeError, setStartTimeError] = React.useState('');
  const [finishTimeDisable, setFinishTimeDisable] = React.useState(true);
  const isValidDate = (date) => date instanceof Date && !Number.isNaN(date.getTime());
  const [reloadList, setReload] = React.useState(false);

  const now = new Date();
  const UserGroup = useSelector((state) => state.user.userProfile.user_groupName);
   const Uservalidation = () => {
    if (UserGroup === 'SuperAdmin') {
      return true;
    }
    toast.error('User not authorise to Schedule the Deployment');
    setDeploymentmode('');
    setFromDateAndTime(new Date());
    setToDateAndTime(new Date());
    setReason('');
    setReleaseNotes('');
    setSubmitDisabled(true);
    console.log(reloadList);
    return false;
  };
     const handleStartTimeChange = (value) => {
    if (!isValidDate(value)) {
      // console.warn('handleStartTimeChange received invalid date:', value);
      setFromDateAndTime(new Date());

      return;
    }
    if (!value || Number.isNaN(value.getTime())) {
      setFromDateAndTime(new Date());
      return;
    }

    if (fromDateAndTime.toISOString() && value.toISOString() <= now.toISOString()) {
      setStartTimeError('start time must be after the current time !!');
      setFinishTimeDisable(true);
    } else {
      setStartTimeError('');
      setToDateAndTime(value.toISOString());
      setFinishTimeDisable(false);
      setReleaseNoteDisabled(false);
    }
  };
  const handleFinishTimeChange = (value) => {
    if (!isValidDate(value)) {
      // console.warn('handleStartTimeChange received invalid date:', value);
      setToDateAndTime(new Date());

      return;
    }
    if (!value || Number.isNaN(value.getTime())) {
      setToDateAndTime(new Date());
      return;
    }
    if (fromDateAndTime.toISOString() && value.toISOString() <= fromDateAndTime.toISOString()) {
      setSubmitDisabled(true);
      setReleaseNoteDisabled(true);
      setTimeError('Finish time must be after the start time');
    } else {
      setTimeError('');
      setReleaseNoteDisabled(false);
    }
  };
  const handleCancel = () => {
    setDeploymentmode('');
    setFromDateAndTime(new Date());
    setToDateAndTime(new Date());
    setReason('');
    setReleaseNotes('');
    setSubmitDisabled(true);
    setReleaseNoteDisabled(true);
    setTimeError('');
    setFinishTimeDisable(true);
    handleClose();
  };
 const submitDeploymentSchedule = () => {
    if (!Uservalidation(userName)) {
      return;
    }
    try {
      const body = {
        DeploymentMode: 'Yes',
        StartTime: fromDateAndTime.toISOString(),
        EndTime: toDateAndTime.toISOString(),
        createdBy: userName,
        createdDate: new Date(),
        Status: 'Scheduled',
        ReleaseNote: releaseNotes,
        Reason: reason,
      };
      setSubmitDisabled(true);
      postDeploymentDetails(body)
        .then((response) => {
          setSubmitDisabled(true);
          toast.success('Deployment schedule submitted successfully');
          setDeploymentmode('');
          setFromDateAndTime(new Date());
          setToDateAndTime(new Date());
          setReason('');
          setReleaseNotes('');
          setReleaseNoteDisabled(true);
          handleClose();
          setReload(true);
          onAddSuccess(response.data);
        })
        .catch((err) => console.error(err));
    } catch (error) {
      console.error('Error submitting deployment schedule:', error);
    }
  };

  React.useEffect(() => {
    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={false}
      fullWidth
      PaperProps={{
        sx: {
          width: { xs: '95vw', sm: '40vw' },
          maxHeight: '85vh',
        },
      }}
    >
      <DialogTitle component="h5" sx={{ textAlign: 'center', fontSize: '2rem' }}>
        Add New Sceduled
      </DialogTitle>

      <DialogContent

        // eslint-disable-next-line react/jsx-props-no-multi-spaces
        sx={{
          overflowY: 'auto',
          maxHeight: '125vh',
          pr: 1,
          pb: 0,
        }}
      >
        <Box display="flex" flexDirection="column" gap={2}>
           <div className="flex items-center justify-center mb-4">
              <Typography variant="body2">
                Info :
              </Typography>
           </div>
            <div className="flex items-center justify-center mb-4">
              <Typography align="center" variant="body2">
                Schedule the start and end time for a release.
                <br />
                All users will be logged out at the start, and won&apos;t be able to access Prism.
                <br />
                Maintainance page will be showing durin the deployment window
              </Typography>
            </div>
            <section className="flex flex-row justify-center w-full gap-10">
              <section className="flex flex-col gap-8 w-[300px] ">
                <div>
                  <div className="flex items-center gap-2 mt-3">
                    <div className="flex items-center justify-center w-4 h-4 p-3 text-white rounded-full bg-secondary-500">
                      <Typography variant="caption" className="font-gothammedium">
                        1
                      </Typography>
                    </div>
                    <Typography variant="body2"> Start Time </Typography>
                  </div>
                  <Box sx={{ paddingTop: '1rem' }}>
                    <div key="step2" className="flex flex-col w-[260px]">
                      <DateTimePicker
                        label="From"
                        inputFormat="dd/MM/yyyy hh:mm a"
                        value={fromDateAndTime}
                        onChange={(date) => {
                          setFromDateAndTime(date);
                          handleStartTimeChange(date);
                        }}
                        minDateTime={now.toISOString()}
                        disablePast
                        renderInput={(params) => <TextField {...params} fullWidth error={!!startTimeError} helperText={startTimeError} />}
                      />
                    </div>
                  </Box>
                </div>
                <div>
                  <div className="flex items-center gap-2">
                    <div className="flex items-center justify-center w-4 h-4 p-3 text-white rounded-full bg-secondary-500">
                      <Typography variant="caption" className="font-gothammedium">
                        2
                      </Typography>
                    </div>
                    <Typography variant="body2">Finish Time</Typography>
                  </div>
                  <Box sx={{ paddingTop: '1rem' }}>
                    <div key="step2" className="flex flex-col w-[260px]">
                      <DateTimePicker
                        label="To"
                        format="dd/MM/yyyy hh:mm a"
                        value={toDateAndTime}
                        minDateTime={fromDateAndTime}
                        onChange={(date) => {
                          setToDateAndTime(date);
                          handleFinishTimeChange(date);
                        }}
                        disabled={!fromDateAndTime}
                        disablePast
                        renderInput={(params) => <TextField {...params} fullWidth error={!!timeError} helperText={timeError} />}
                      />
                    </div>
                  </Box>
                </div>
              </section>
              <section className="flex flex-col w-[400px]">
                {(deploymentmode === 'Yes' || deploymentmode === '') ? (
                  <div>
                    <div className="flex items-center gap-2 mt-3">
                      <div className="flex items-center justify-center w-4 h-4 p-3 text-white rounded-full bg-secondary-500">
                        <Typography variant="caption" className="font-gothammedium">
                          3
                        </Typography>
                      </div>
                      <Typography variant="body2">
                        Release Notes
                      </Typography>
                    </div>
                    <Box sx={{ paddingTop: '1rem' }}>
                      <div key="step2" className="flex flex-col w-[300px]">
                           <ReleaseNoteEditor submitDisabled={submitDisabled} setSubmitDisabled={setSubmitDisabled} releaseNotes={releaseNotes} setReleaseNotes={setReleaseNotes} />
                      </div>
                    </Box>
                  </div>
                ) : (
                  <div>
                    <div className="flex items-center gap-2 mt-3">
                      <div className="flex items-center justify-center w-4 h-4 p-3 text-white rounded-full bg-secondary-500">
                        <Typography variant="caption" className="font-gothammedium">
                          4
                        </Typography>
                      </div>
                      <Typography variant="body2">
                        Reason
                      </Typography>
                    </div>
                    <Box sx={{ paddingTop: '1rem' }}>
                      <div key="step2" className="flex flex-col w-[300px]">
                        <FormControl>
                          <TextField
                            label="Reason"
                            placeholder="Type or Paste in your Reason here."
                            multiline
                            disabled={releaseNoteDisabled}
                            rows={12.6}
                            value={reason}
                            onChange={(e) => {
                              setReason(e.target.value);
                              setSubmitDisabled(!e.target.value.trim());
                            }}
                          />
                        </FormControl>
                      </div>
                    </Box>
                  </div>
                )}
              </section>
            </section>
            <div className="flex items-center w-[800px] gap-9 mt-12">
              <hr className="w-full" />
            </div>
            <section className="flex flex-col items-right gap-9">
              <div className="flex items-center justify-end gap-6">
                <div key="step5" className="flex flex-col w-[90px]">
                  <Box className="flex items-center justify-center gap-2 mt-4">
                    <Button
                      variant="contained"
                      onClick={() => {
                        handleCancel();
                      }}
                    >
                      Cancle
                    </Button>
                  </Box>
                </div>
                <div key="step6">
                  <Box className="flex items-center gap-2 mt-4">
                    <Button
                      variant="contained"
                      disabled={submitDisabled}
                      onClick={() => {
                        submitDeploymentSchedule();
                      }}
                    >
                      Submit
                    </Button>
                  </Box>
                </div>
              </div>
            </section>
        </Box>
      </DialogContent>

    </Dialog>

  );
}

export default CreateNewSchedule;
